export default __webpack_public_path__ + "../staticImages/winefinder-sprite-occasion_geburtstag-2x.png";